
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/check-report",
      function () {
        return require("private-next-pages/docs/errors/check-report.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/check-report"])
      });
    }
  